import classNamesBase from 'classnames';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';

var classNames = function classNames(common, desktop, notDesktop) {
  var isDesktop = useMediaIsDesktop();
  var additional = isDesktop ? classNamesBase(desktop) : classNamesBase(notDesktop);
  return classNamesBase(common, additional);
};

export { classNames };